import { createFileRoute, Outlet } from '@tanstack/react-router'

import { CustomerPage } from '../../components/templates/customer-page.tsx'

export const Route = createFileRoute('/(customer)/_portal')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <CustomerPage>
      <Outlet />
    </CustomerPage>
  )
}
